import { createFileRoute } from '@tanstack/react-router';
import { ProductRegister } from '../../../features/settings/components/ProductRegister';

/** Products + pack-spec CRUD (BUILD_SPEC.md §5.2) — type, base UOM, moisture
 * flags, reorder points, VAT treatment, plus a nested pack-spec editor (bulk
 * product + qty per pack + packaging lines). Plan.md G26. */
export const Route = createFileRoute('/_authenticated/settings/products')({
  component: ProductRegister,
});
